class SearchForm {
  constructor( el ) {
    this.formel = el;
    this.advancedmenubutton = this.formel.querySelectorAll('.showadvanced');
    this.localityconts = this.formel.querySelectorAll('.localitycont');
    this.categsubcategconts = this.formel.querySelectorAll('.categsubcategcont');
    this.searchpagelinks = this.formel.querySelectorAll('.page-link');
  }

  async selectlocality( localitysuggestion, localityinput, regionidinput, departementidinput, villeidinput, distancecont ){
    let SearchForm = this;
    regionidinput.value = '';
    departementidinput.value = '';
    villeidinput.value = '';
    localityinput.value = '';
    if( localitysuggestion.dataset.type == 'region' ){
      regionidinput.value = localitysuggestion.dataset.id;
      localityinput.value = localitysuggestion.dataset.label;
      if( distancecont ){
        distancecont.classList.add( 'd-none' );
      }
    } else if( localitysuggestion.dataset.type == 'departement' ){
      departementidinput.value = localitysuggestion.dataset.id;
      localityinput.value = localitysuggestion.dataset.label;
      if( distancecont ){
        distancecont.classList.add( 'd-none' );
      }
    } else if( localitysuggestion.dataset.type == 'ville' ){
      villeidinput.value = localitysuggestion.dataset.id;
      localityinput.value = localitysuggestion.dataset.label;
      if( distancecont ){
        distancecont.classList.remove( 'd-none' );
      }
    }
    else if( localitysuggestion.dataset.type == 'mygeoloc' ){
      localityinput.value = 'Autour de moi';
      navigator.geolocation.getCurrentPosition((position) => {
        SearchForm.formel.querySelector('#mylatitude').value = position.coords.latitude;
        SearchForm.formel.querySelector('#mylongitude').value =  position.coords.longitude;
      });

      if( distancecont ){
        distancecont.classList.remove( 'd-none' );
      }
    }
  }

  async displaylocalities(localityinput, regionidinput, departementidinput, villeidinput, distancecont){
    let SearchForm = this;
    let localitysuggestcont = localityinput.parentNode.querySelector('.locality-suggests');
    if( localityinput.value && localitysuggestcont ){
      if( localityinput.value.length >= 2 ){
        return fetch( '/location-ajax', {
          cache: "no-store",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            term:localityinput.value,
          }),
        }).then( (response) => {
          return response.json();
        }).then(function(data) {
          localitysuggestcont.innerHTML = '';
          if( data.items.length ){

            data.items.map( function(locality) {
              let localitysuggestion = document.createElement("div");
              localitysuggestion.dataset.type = locality.type;
              localitysuggestion.dataset.id = locality.id;
              localitysuggestion.dataset.label = locality.name;
              localitysuggestion.classList.add( 'locality-suggest' );
              localitysuggestion.innerHTML = locality.name + ( locality.sub? '<span>'+locality.sub+'</span>' : '' );
              localitysuggestcont.appendChild( localitysuggestion );
              localitysuggestion.addEventListener('click', (e) => {
                SearchForm.selectlocality( localitysuggestion, localityinput, regionidinput, departementidinput, villeidinput, distancecont );
              });
            });
          } else {
            let localitysuggestion = document.createElement("div");
            localitysuggestion.classList.add( 'locality-nosuggest' );
            localitysuggestion.innerHTML = 'Aucun résultat';
            localitysuggestcont.appendChild( localitysuggestion );
          }
        });
      } else {
        localitysuggestcont.innerHTML = '';
        let localitysuggestion = document.createElement("div");
        localitysuggestion.classList.add( 'locality-nosuggest' );
        localitysuggestion.innerHTML = 'Veuillez saisir au moins 2 caractères';
        localitysuggestcont.appendChild( localitysuggestion );
      }
    }
  }

  async initLocalities(){
    let SearchForm = this;
    this.localityconts.forEach((localitycont) => {
      let localityinput = localitycont.querySelector('.locality');
      let regionidinput = localitycont.querySelector('.regionid');
      let departementidinput = localitycont.querySelector('.departementid');
      let villeidinput = localitycont.querySelector('.villeid');
      let distancecont = localitycont.querySelector('.distance');

      if( localityinput && regionidinput && departementidinput && villeidinput ){
        let localitysuggestionscont = document.createElement("div");
        localitysuggestionscont.classList.add( 'locality-suggests' );
        localityinput.after( localitysuggestionscont );
        localityinput.addEventListener('focus', (e) => { localitysuggestionscont.style.display = 'block'; });
        localityinput.addEventListener('blur', (e) => { 
          setTimeout( () => {
            localitysuggestionscont.style.display = 'none'; 
          }, 200 );
        });
        localityinput.addEventListener('keyup', (e) => { SearchForm.displaylocalities(localityinput, regionidinput, departementidinput, villeidinput, distancecont) } );
      }
      
    });
  }

  async initCategSubCateg(){
    this.categsubcategconts.forEach((categsubcategcont) => {
      let categinput = categsubcategcont.querySelector('.categinput');
      let subcateginput = categsubcategcont.querySelector('.subcateginput');
      let subcategcont = categsubcategcont.querySelector('.subcategcont');

      if( categinput && subcateginput && subcategcont ){
        categinput.addEventListener('change', (e) => { 
          //empty subcateg
          subcateginput.querySelectorAll('option').forEach( (opt) => { 
            opt.selected = false; 
          });

          //show good optgroup
          subcategcont.classList.add( 'd-none' );
          subcateginput.querySelectorAll('optgroup').forEach( (optgroup) => { 
            optgroup.classList.add( 'd-none' );
            if( optgroup.dataset.subcategoryid == categinput.value ){
              optgroup.classList.remove( 'd-none' );
              subcategcont.classList.remove( 'd-none' );
            }
          });
        });
      }
    });
  }

  async initSimpleAdvanced(){
    // show simple / advanced
    this.advancedmenubutton.forEach((advancedmenubtn) => {
      advancedmenubtn.addEventListener('click', (e)=>{
        e.preventDefault();
        if( this.formel.classList.contains('advanced') ){
          this.formel.classList.remove('advanced')
        } else {
          this.formel.classList.add('advanced')
        }
      });
    });
  }

  async initPagination(){
    let SearchForm = this;
    let searchpageinput = SearchForm.formel.querySelector('.search-pageinput');
    if( searchpageinput ){
      this.searchpagelinks.forEach((searchpagelink) => {
        searchpagelink.addEventListener( 'click', (e) => {
          searchpageinput.value = searchpagelink.dataset.page;
          SearchForm.formel.submit();
        });
      });
    }
  }



  async init(){
    this.initSimpleAdvanced();
    this.initLocalities();
    this.initCategSubCateg();
    this.initPagination();
  }
}

DOMReady( function(){
  [... document.querySelectorAll('.form-search')].map( l => {
    let searchform = new SearchForm(l);
    searchform.init();
  });

  document.querySelector('#showcriteria').addEventListener('click',function(){
    if(document.querySelector('.morecriteria').classList.contains('d-none')){
      document.querySelector('.morecriteria').classList.remove('d-none');
    }
    else{
      document.querySelector('.morecriteria').classList.add('d-none');
    }
  });
});
